import React, { useState } from 'react'

import "./WelcomeVideo.scss"

import {
    productTourWatched,
} from 'components/CommunityOnboardingComp/SetupDetailsUtilities/utils';
import CompleteButton from 'components/CommunityOnboardingComp/SetupDetailsUtilities/CompleteButton';
import ProductTourVideo from 'components/CommunityOnboardingComp/SetupDetailsUtilities/ProductTourVideo';

export interface IBasicSetupDetails {
    groupData: any
    subdomain: string
    compSelected: any
    description: string
}

const WelcomeVideo: React.FC<IBasicSetupDetails> = ({
    groupData, subdomain, compSelected, description
}) => {
    const [isdisplayVideo, setDisplayVideo] = useState(false);

    return (
        <>
            {
                isdisplayVideo && (
                    <ProductTourVideo
                        isdisplayVideo={isdisplayVideo}
                        setDisplayVideo={setDisplayVideo}
                        videoId={1093860181}
                        sectionTitle="Watch Product Tour"
                    />
                )
            }
            {
                compSelected === 5 &&
                <ul className='setup-details-items'>
                        <span className='setup-details-items-span'>{description}</span>

                        <li className='setup-detail'>
                            <div className="onboarding-message-content-container">
                                <div className="onboarding-message-content-container-middle">
                                    <div className="onboarding-message-content-container-resources">
                                        <span>Resources</span>
                                        <ul className="resource-list">
                                            <li>
                                                <a
                                                    href="https://community.group.app/courses/groupapp-101-training"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    GroupApp 101 Training
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href="https://community.group.app/invite"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Join our community
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href="https://help.group.app/en"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Help documentation
                                                </a>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                                <div
                                    className="onboarding-message-content"
                                    onClick={() => setDisplayVideo(true)}
                                >
                                    <img
                                        className="onboarding-message-content-img"
                                        src='https://static.group.app/assets/getting-started/getting-started-thumbnail.png'
                                        alt="GroupApp Demo Walkthrough"
                                    />
                                </div>
                            </div>


                            <div className='setup-item-btn'>
                                <CompleteButton
                                    configSectionId="product_tour_watched"
                                    groupData={groupData}
                                    isCompleted={productTourWatched(groupData)}
                                />

                            </div>
                        </li>
                </ul>
            }
        </>
    )
}

export default WelcomeVideo
